import { render, staticRenderFns } from "./brokerage.vue?vue&type=template&id=baa98b42&scoped=true&"
import script from "./brokerage.vue?vue&type=script&lang=js&"
export * from "./brokerage.vue?vue&type=script&lang=js&"
import style0 from "./brokerage.vue?vue&type=style&index=0&id=baa98b42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa98b42",
  null
  
)

export default component.exports